import React, { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';
import CurrencySwitcher from './CurrencySwitcher';

const OtherList = ({ gid, filter, initialPlans, initialCurrencyInfo }) => {
  const [plans, setPlans] = useState(initialPlans || []);
  const [loading, setLoading] = useState(true);
  const [currency, setCurrency] = useState('usd');
  const [currencyInfo, setCurrencyInfo] = useState(initialCurrencyInfo || {
    inr_rate: 0,
    euro_rate: 0,
    show_currency: '1',
    trace_country: ''
  });

  useEffect(() => {
    // Setup initial currency
    if (initialCurrencyInfo) {
      const stored = localStorage.getItem('osp_currency');
      const isIndiaTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Kolkata' || Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Calcutta';
      if (stored) {
        setCurrency(stored);
      } else if (initialCurrencyInfo.trace_country === 'India' || isIndiaTimezone) {
        setCurrency('inr');
      }
    }

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    // Listen to global currency changes
    const handleCurrencyChange = (e) => {
      if (e.detail) {
        setCurrency(e.detail);
      }
    };
    window.addEventListener('ospCurrencyChange', handleCurrencyChange);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('ospCurrencyChange', handleCurrencyChange);
    };
  }, [initialCurrencyInfo]);

  // Price formatter
  const formatPrice = (usdPrice) => {
    const priceVal = parseFloat(usdPrice);
    if (isNaN(priceVal) || priceVal <= 0) return '-';

    if (currency === 'inr' && currencyInfo.inr_rate) {
      return `₹${Math.round(priceVal * currencyInfo.inr_rate)}`;
    } else if (currency === 'eur' && currencyInfo.euro_rate) {
      return `€${(priceVal * currencyInfo.euro_rate).toFixed(2)}`;
    }
    return `$${priceVal.toFixed(2)}`;
  };

  if (loading) {
    return (
      <div id="osp-sheet" className="osp-responsive-container">
        <div className="osp-skeleton-cards osp-always-visible">
          {[1, 2, 3, 4].map(i => (
            <div className="osp-skeleton-card" key={i}>
              <div className="osp-skeleton-card-header">
                <div className="osp-skeleton-avatar"></div>
                <div className="osp-skeleton-title"></div>
              </div>
              <div className="osp-skeleton-card-body">
                <div className="osp-skeleton-line"></div>
                <div className="osp-skeleton-line"></div>
                <div className="osp-skeleton-line"></div>
                <div className="osp-skeleton-line"></div>
              </div>
              <div className="osp-skeleton-card-footer"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div id="osp-sheet" className="osp-responsive-container">
      {/* Switcher aligned to the right */}
      <div className="osp-controls-bar" style={{ justifyContent: 'flex-end' }}>
        <CurrencySwitcher traceIp={currencyInfo.trace_country} />
      </div>

      {plans.length === 0 ? (
        <div style={{ padding: '20px', textAlign: 'center', background: '#fff', border: '1px solid #dee2e6', borderRadius: '8px' }}>
          Nothing Found !
        </div>
      ) : (
        <div className="osp-other">
          {plans.map((plan) => {
            const hasOffer = plan.best_offer?.savings > 1 && plan.best_offer?.offer_price > 0;
            const sanitizedDescription = DOMPurify.sanitize(plan.description);

            return (
              <div className="osp-other-in" key={plan.pid}>
                <div className="oth-head">
                  <div className="icon">
                    {plan.icon_name ? (
                      <a href={plan.buy_url}>
                        <img 
                          src={`${window.ospFrontendData?.pluginUrl || ''}/assets/image/${plan.icon_name}.png`} 
                          alt={plan.name} 
                        />
                      </a>
                    ) : (
                      <i className="flag us"></i>
                    )}
                  </div>
                  <h3>{plan.name}</h3>
                </div>

                <div 
                  className="oth-body" 
                  dangerouslySetInnerHTML={{ __html: sanitizedDescription }}
                />

                <div className="oth-footer">
                  <div className="osp-price">
                    {plan.is_gsuite ? (
                      // Display G Suite pricing
                      <>
                        Monthly Price: {formatPrice(plan.display_price)} <em>Monthly</em>
                      </>
                    ) : (
                      // Display Standard pricing
                      <>
                        Monthly Price: {formatPrice(plan.display_price)} <em>{plan.display_cycle}</em>
                        {hasOffer && (
                          <>
                            <br />
                            Offer Price: {formatPrice(plan.best_offer.offer_price)}{' '}
                            <em>(Save {plan.best_offer.savings}%)</em>
                          </>
                        )}
                      </>
                    )}
                  </div>

                  <a href={plan.buy_url}>
                    <button className="buy-now">
                      <span className="dashicons dashicons-admin-generic"></span> Configure
                    </button>
                  </a>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default OtherList;
